import { Component, OnInit,ViewChild} from '@angular/core';
import * as moment from 'moment/moment';
import { Http } from '@angular/http';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Popup } from 'ng2-opd-popup';
import { debugOutputAstAsTypeScript } from '@angular/compiler';
@Component({
  selector: 'app-travelcost',
  templateUrl: './travelcost.component.html',
  styleUrls: ['./travelcost.component.scss']
})
export class TravelcostComponent implements OnInit {
  ToolTip="Delete is not allowed since it is used in contract registration page";
  ToolTip1="Edit is not allowed since it is used in contract registration page"
  ListpreventiveMaintenanceDetails=[];
loading:boolean=true;
isTravelCostListLoaded:boolean=false;
isDeleteAvailabilityLoaded:boolean=false;
numbersAllow:boolean=false;
travelcost_err:boolean=false;
TravelCost:any;
btnName:string="Submit";
isValid:boolean=false;
EditObjectId:any;
orgId:number;
userId:number;
msgtext:string="";
ListTravelCostDetails=[];
startingCount:number = 0;
endingCount:number = 0;
p: number = 1;
@ViewChild('delete') delete: Popup;
@ViewChild('Askdelete') Askdelete: Popup;
deleteId:any;
  constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) { }

  ngOnInit() {
   this.loading=true;
   this.isTravelCostListLoaded = false;
   this.isDeleteAvailabilityLoaded = false;
   if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
    window.location.href = 'https://still.alshirawi.com/highmessaging/';
  } else {
    this.orgId=this.route.params['value'].orgId;
    this.userId=this.route.params['value'].userId;
    console.log('OrgId '+ this.orgId);
    console.log('UserId '+ this.userId);
  }
  this.getAllTravelCostDetails();
// this.checkToolTip();
  }

  updateLoadingState() {
    this.loading = !(this.isTravelCostListLoaded && this.isDeleteAvailabilityLoaded);
  }


  checkToolTip(){
    if(this.ListTravelCostDetails.length==0||this.ListTravelCostDetails==undefined){
      this.getAllTravelCostDetails();
    }else if(this.ListpreventiveMaintenanceDetails.length==0||this.ListpreventiveMaintenanceDetails==undefined){
      this.getAllPreventiveMaintenanceDetails();
    }else{
      for(let lt=0;lt<this.ListTravelCostDetails.length;lt++){
        for(let lp=0;lp<this.ListpreventiveMaintenanceDetails.length;lp++){
          for(let s=0;s<this.ListpreventiveMaintenanceDetails[lp].Servicedetails.length;s++){
            if(this.ListTravelCostDetails[lt].TravelCost==this.ListpreventiveMaintenanceDetails[lp].Servicedetails[s].travel_Cost){
              this.ListTravelCostDetails[lt].status=true;
            }
          }
        }
      }
    }
  }

  getAllTravelCostDetails(){
    this.loading = true;
    this.isTravelCostListLoaded = false;
    this.isDeleteAvailabilityLoaded = false;
    let TCobj={
      'orgId':this.orgId
    }

    return this.http.post('/api/getTravelCost', TCobj).subscribe(res=>{
    
      let ResponeTC = res.json();
    
        this.ListTravelCostDetails=ResponeTC
        console.log(this.ListTravelCostDetails)
        if(ResponeTC.length > 0) {
          this.getCount();
          this.isTravelCostListLoaded = true;
          this.loadDeleteAvailability();
        } else {
          this.isTravelCostListLoaded = true;
          this.isDeleteAvailabilityLoaded = true;
          this.updateLoadingState();
        }
    
    },err=>{
      this.isTravelCostListLoaded = true;
      this.isDeleteAvailabilityLoaded = true;
      this.updateLoadingState();
      if(err.status != 200){
        this.msgtext = "Unable to load the Value";
        this.getWarningFunction(this.msgtext);
      }
    })
  }

  loadDeleteAvailability() {
    let travelCostIds = [];

    for(let i=0;i<this.ListTravelCostDetails.length;i++) {
      this.ListTravelCostDetails[i].status = false;
      this.ListTravelCostDetails[i].deleteBlockedReason = '';
      travelCostIds.push(this.ListTravelCostDetails[i]._id);
    }

    return this.http.post('/api/getTravelCostDeleteAvailability', {
      'ids':travelCostIds,
      'orgId':this.orgId
    }).subscribe(
      res => {
        let availabilityResponse = res.json().availability || {};

        for(let i=0;i<this.ListTravelCostDetails.length;i++) {
          if(availabilityResponse[String(this.ListTravelCostDetails[i]._id)] && availabilityResponse[String(this.ListTravelCostDetails[i]._id)].canDelete === false) {
            this.ListTravelCostDetails[i].status = true;
            this.ListTravelCostDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListTravelCostDetails[i]._id)].reason || this.ToolTip;
          }
        }

        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
      },err => {
        this.isDeleteAvailabilityLoaded = true;
        this.updateLoadingState();
        if(err.status != 200){
          this.msgtext = "Unable to validate delete availability";
          this.getWarningFunction(this.msgtext);
        }
      }
    )
  }

  getCount(){
    if(this.p < Math.ceil(this.ListTravelCostDetails.length/10)){
      this.startingCount = (this.p-1)*10;
      if(this.startingCount == 0){
        this.startingCount = 1;
      }
      this.endingCount = this.p*10;
      console.log('List Length '+ this.ListTravelCostDetails.length);
   console.log('List startingCount '+ this.startingCount);
   console.log('List endingCount '+ this.endingCount);
    } else if(this.p == Math.ceil(this.ListTravelCostDetails.length/10)){
      let count = this.ListTravelCostDetails.length%10;
      this.startingCount = (this.p-1)*10;
      this.endingCount = this.startingCount + count;
      if(this.startingCount == 0){
        this.startingCount = 1;
        this.endingCount = count;
      }
      console.log('List Length '+ this.ListTravelCostDetails.length);
   console.log('List startingCount '+ this.startingCount);
   console.log('List endingCount '+ this.endingCount);
    }
   }
   getAllPreventiveMaintenanceDetails() {
		
		let reqPMSObj = {
		  'orgId':this.orgId
		}
		return this.http.post('/api/getAllPreventiveMaintenanceDetails',reqPMSObj).subscribe(
		 res => {
		 
		  
      let Response = res.json();
      if(Response.length>0){
        this.ListpreventiveMaintenanceDetails=Response;
     
        console.log("preventiveMaintainance",res.json());
       
      }else{

      }
    
	
		  },(err)=>{
		   
		  })
	  }

   Delete(index, deleteId) {
    if(this.ListTravelCostDetails[index] && this.ListTravelCostDetails[index].status === true) {
      this.msgtext = this.ListTravelCostDetails[index].deleteBlockedReason || this.ToolTip;
      this.getWarningFunction(this.msgtext);
      return false;
    }
    
		this.reset();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
          header: "Delete Travel Cost"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {

		this.Askdelete.hide();
    this.loading=true;
		let reqMakeObj = {
          'deleteId':this.deleteId,
          'orgId':this.orgId
	    }
	    return this.http.post('/api/deleteTravelCost', reqMakeObj).subscribe(
	      res => {
        
          let Response = res.json();
          if(Response && Response.canDelete === false) {
            this.loading=false;
            this.msgtext = Response.reason || this.ToolTip;
            this.getWarningFunction(this.msgtext);
            this.getAllTravelCostDetails();
            return false;
          }
          this.getAllTravelCostDetails();
          this.delete.options = {
		        showButtons: false, // You can hide this in case you want to use custom 
		        color: "#4180ab",
		        header: "DELETE TRAVEL COST"
		    };
		    this.delete.show(this.delete.options);
        this.deleteId="";
        this.reset();
        //  this.MYSQLDeletemake();
      //  this.getAllTravelCostDetails();
	    },(err)=>{
          this.loading=false;
	        this.msgtext = "Unable to Delete the value";
	        this.getWarningFunction(this.msgtext);
	    })
  }
  
  deletesuccessOk() {
		this.delete.hide();
	}
  _keyPress(event: any) {
  
    // if(event.key) {

    // }
    if(event.keyCode == 8 ) {
      return true;
    } else {
      const pattern = /[0-9\.\ ]/;
      let inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
    
  }

  InputCost(value){
  

      if(this.TravelCost==""||this.TravelCost==undefined||this.TravelCost==null){
      this.travelcost_err=true;
      this.isValid=true;
      }else{
       this.travelcost_err=false;
      this.isValid=false;
      }
  }


   reset(){
    this.isValid=false;
    this.travelcost_err=false;
    this.TravelCost="";
    this.btnName = 'Submit';
   }

  
   showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD TRAVEL COST",message:"The Data Added Successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE TRAVEL COST",message:"The Data Updated Successfully"});
	}

  showDuplicateDialog(message: any){
    this.dialogService.addDialog(AlertComponent,{title:"TRAVEL COST",message:message});
  }

   addTravelcost(){
   
    if(this.TravelCost == "" || this.TravelCost == undefined || this.TravelCost == null||/^\s*$/.test(this.TravelCost)) {
      this.travelcost_err=true;
      this.loading=false;
       
        }else {

          if(this.EditObjectId == null || this.EditObjectId == undefined || this.EditObjectId == ""){

	let reqTCObj = {
	            'travelCost':this.TravelCost,
			        'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
      }
      return this.http.post('/api/addTravelCost', reqTCObj).subscribe(res=>{
     
        let TravelCostResponse = res.json();
        
        if(TravelCostResponse.message == 'This Travel Cost Already Exists') {
          this.loading=false;
          this.showDuplicateDialog('This Travel Cost Already Exists');
          this.reset();
        } else {
          //this.MYSQLEntryMakeAdd();
          this.showAlertForAddingdata();
          this.getAllTravelCostDetails();
          this.reset();
        }        
      },err=>{
        this.loading=false;
        if(err.status != 200){
          this.msgtext = "Unable to Add the Travel Cost Value";
          this.getWarningFunction(this.msgtext);
        }
      })
          }else{
            let reqTCObj = {
			        'travelCost':this.TravelCost,
			        'orgId':this.orgId,
			        'updated_By':this.userId,
			        'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
			        'objectId':this.EditObjectId
			      }
            return this.http.post('/api/UpdateTravelCost', reqTCObj).subscribe(res=>{
              let TravelCostResponse = res.json();
			        if(TravelCostResponse.message == 'This Travel Cost Already Exists') {
			          this.loading=false;
                this.showDuplicateDialog('This Travel Cost Already Exists');
                this.reset();
			        } else {
                //this.MYSQLEntryMakeUpdate();
                this.showAlertForUpdatingdata();
                this.getAllTravelCostDetails();
                this.reset();
			        }
            },err=>{
              if(err.status != 200){
			          this.msgtext = "Unable to Add the Travel Cost Value";
			          this.getWarningFunction(this.msgtext);
			        }
            })




         }



      }
   }
  //  finishing of addtravelcost()
  Editing(index, objectId) {

		this.reset();
		this.EditObjectId = objectId;
		this.btnName = 'Update';
		for(let i=0;i<this.ListTravelCostDetails.length;i++) {
			if(this.ListTravelCostDetails[i]._id == objectId) {
				this.TravelCost = this.ListTravelCostDetails[i].TravelCost.toUpperCase();
			}
		}
		
	}

getWarningFunction(errMsg) {
  var toastOptions:ToastOptions = {
      title: "TravelCost",
      msg: errMsg,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
  };
    this.toastyService.warning(toastOptions);
}




}



// WEBPACK FOOTER //
// ./client/app/travelcost/travelcost.component.ts